import { useContext } from 'react';
import { ClientRoutesContext } from '../ClientRoutesContext';

const useClientRoutesContext = () => {
  const routes = useContext(ClientRoutesContext);
  if (!routes) throw Error('Unable to use useClientRoutesContext hook outside of Provider ');

  return routes;
};

export default useClientRoutesContext;
